import { hasPermission } from '@hypeit-gmbh/hypeit-ui-core';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_rootLayout/artists')({
  preload: false,
  beforeLoad: ({ context: { permissions } }) => {
    if (
      !hasPermission(permissions, {
        permission: 'ARTISTS_GENERAL',
        action: 'READ',
      })
    ) {
      throw redirect({
        to: '/',
        replace: true,
        throw: true,
      });
    }
  },
});
